<template>
  <hic-index-page title="菜单管理" hide-footer>
    <template slot="buttons">
      <el-dropdown v-if="permission.masterdata_dict_create" split-button type="primary" @click="create" size="small" @command="handleCmd">
        <i class="el-icon-plus"></i> 新建
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="user.tenantId != 1" command="copy"> <i class="el-icon-document-copy" /> 从租主复制</el-dropdown-item>
          <el-dropdown-item command="del"> <i class="el-icon-delete" /> 清空所有菜单</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
    <template slot="search">
      <el-input class="condition-wide" v-model="condition.keyword" placeholder="名称或编码" size="small" v-on:keyup.enter.native="page" clearable @clear="page">
        <el-button type="info" slot="append" icon="el-icon-search" @click="page">查询</el-button>
      </el-input>
    </template>
    <el-container class="f-h">
      <el-main>
        <el-skeleton v-if="meta.loading" :rows="10" animated/>
        <el-table v-show="!meta.loading" height="100%" :data="entities.items" row-key="id" default-expand-all @filter-change="filterChanged" @sort-change="sortChanged" class="main-table">
          <el-table-column label="操作" width="100" align="center" key="action">
            <template slot-scope="scope">
              <el-button v-if="permission.masterdata_menus_edit && scope.row.id" type="primary" icon="el-icon-edit" title="编辑" size="mini" @click="edit(scope.row)" circle plain />
              <hic-regret-button v-if="permission.masterdata_menus_edit && scope.row.id" type="danger" icon="el-icon-delete" circle plain @click="del(scope.row, scope.$index)" :seconds="5" size="mini" badge="success" :disabled="!scope.row.id" class="left-pad"></hic-regret-button>
              <el-tag v-if="!scope.row.id" size="mini" type="info">已删除</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="名称" prop="name" key="name" sortable="custom">
            <template slot-scope="{ row }">
              <b>{{ row.name }}</b>
            </template>
          </el-table-column>
          <el-table-column label="编码" prop="code" key="code" sortable="custom"> </el-table-column>
          <el-table-column label="图标" prop="icon" min-width="50" align="center" key="icon">
            <template slot-scope="{ row }">
              <i :class="row.icon" style="font-size: 20px"></i>
            </template>
          </el-table-column>
          <el-table-column label="父菜单" width="90" align="center" :filters="[{ text: '是', value: true }]" :filter-multiple="false" column-key="firstMenu">
            <template slot-scope="{ row }">
              <el-tag v-if="row.firstMenu" type="success" effect="plain" size="mini">是</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="上级" prop="firstMenuId" min-width="50" align="center" key="firstMenuId">
            <template slot-scope="{ row }">
              {{ getMenuName(row.firstMenuId) }}
            </template>
          </el-table-column>
          <el-table-column label="权限" prop="permissionCode" min-width="100" align="center" key="permissionCode" />
          <el-table-column label="排序" prop="seqNo" min-width="60" align="center" key="seqNo" sortable="custom" />
          <el-table-column label="类型" prop="menuType" min-width="60" key="menuType" sortable="custom">
            <template slot-scope="{ row }">
              <span>{{ row.menuType }}</span>
            </template>
          </el-table-column>
          <el-table-column label="停用" prop="menuType" min-width="60" key="disabled" sortable="custom">
            <template slot-scope="{ row }">
              <el-tag v-if="row.disabled" type="danger" size="mini" hit>是</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-aside width="auto">
        <br />
        <el-tabs v-model="condition.clientId" @tab-click="page" size="mini" tab-position="right">
          <el-tab-pane v-for="sys in clientSys" :label="sys.text" :name="sys.code" :key="sys.code">
          </el-tab-pane>
        </el-tabs>
      </el-aside>
    </el-container>
    <Editor v-model="entity" :visible.sync="showEditor" @ok="entityUpdated" />
  </hic-index-page>
</template>

<script>
  import api from "./api";
  import store from "@/common/store";
  import { mapGetters } from "sw-hic";
  export default {
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      if (!store.getters.permission.masterdata_dict_query) {
        next({
          name: "err",
          params: { err: this.$cfg.errs.NeedPromission },
        });
      } else {
        next();
      }
    },
    components: {
      Editor: () => import("./editor"),
    },
    data() {
      return {
        condition: {
          sort: "seqNo",
          asc: true,
          pageIndexOnView: 1,
        },
        meta: {
          loading: false,
        },
        // searchLoading: false,
        entities: {},
        showEditor: false,
        entity: {},
      };
    },
    computed: {
      ...mapGetters(["permission", "dict", "user"]),
      isMaster() {
        return this.user.tenantId == 1
      },
      clientSys() {
        if (this.isMaster) {
          return this.dict.Sys
        }
        return this.dict.MySys
      }
    },
    mounted() {
      this.condition.clientId = this.dict.MySys[0].code;
      this.page();
    },
    methods: {
      changeApply(app) {},
      page() {
        let _this = this;
        _this.meta.loading = true;
        api.Menus.query(this.condition).then((res) => {
          _this.entities = res;
          _this.meta.loading = false;
        });
      },
      create() {
        this.$set(this, "entity", { clientId: this.condition.clientId });
        this.showEditor = true;
      },
      edit(row) {
        this.$set(this, "entity", JSON.parse(JSON.stringify(row)));
        this.showEditor = true;
      },
      entityUpdated(value) {
        this.$store.dispatch("loadDicts", value.type);
        this.page();
      },
      sortChanged(col) {
        if (!col.order) {
          this.condition.sort = "id";
          this.condition.asc = false;
        } else {
          this.condition.sort = col.prop;
          this.condition.asc = col.order == "ascending";
        }
        this.page();
      },
      filterChanged(options) {
        Object.assign(this.condition, options);
        this.page();
      },
      applyChanged() {},
      del(row, index) {
        let _this = this;
        api.Menus.del(row.id).then((res) => {
          _this.entities.items.splice(index, 1, {});
          _this.$message.success("删除成功！");
        });
      },
      getMenuName(id) {
        let menu = this.entities.items.find((i) => i.id == id);
        if (menu) {
          return menu.name;
        }
        return id;
      },
      handleCmd(cmd) {
        if (cmd == "copy") {
          this.$confirm("确定复制租主所有菜单项吗？")
            .then((res) => {
              api.Menus.copy(this.condition.clientId).then((res) => {
                this.page();
              });
            })
            .catch((err) => {});
        }
        if (cmd == "del") {
          this.$confirm("确定要清空所有菜单项吗？该操作不可逆！")
            .then((res) => {
              api.Menus.batchDel(this.condition.clientId).then((res) => {
                this.page();
              });
            })
            .catch((err) => {});
        }
      },
    },
  };
</script>
